// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3IR2B","question":"styles_question__16K2t","description":"styles_description__3Qgxp"};